import { GeoJSON } from 'react-leaflet';
import React, { useMemo, useRef } from 'react';
import { useMapStore } from 'contexts/RootStore.context';
import { observer } from 'mobx-react';
import { isNumber } from 'lodash';

// this component will render a single geoJson layer from unit.geojson, with feature data filtered by level id that was clicked.
export const UnitGeoJsonLayer = observer(() => {
  const { getOrdinalUnits, selectedBuildingId, selectedFloor } = useMapStore()

  const keyRef: any = useRef();

  const units = useMemo(() => {
    // this key is for re-render of units on floor changing.
    keyRef.current = Math.random() * 1000;
    return selectedBuildingId && isNumber(selectedFloor)
      ? getOrdinalUnits(selectedBuildingId, selectedFloor)
      : []
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBuildingId, selectedFloor])

  if (!selectedBuildingId || selectedFloor === null)
    return <></>

  return (
    <GeoJSON
      style={{
        fillColor: '#ffffff',
        fillOpacity: 1,
        color: '#B3C5DA',
        weight: 1.5,
      }}
      key={keyRef.current}
      data={units as any}
    />
  );
})
